import { Routes } from '@angular/router';
import { loginGuard } from './shared/guard/login-guard';
import { authGuard } from './shared/guard/auth-guard';

export const routes: Routes = [
    {
        path: 'login',
        canActivate: [loginGuard],
        loadComponent: () => import('./views/login/login').then((m) => m.Login),
    },
    {
        path: '',
        canActivate: [authGuard],
        children: [
            {
                path: 'importacao',
                loadComponent: () => import('./views/importacao/importacao').then((m) => m.Importacao),
            },
            {
                path: 'ficha-tecnica',
                loadComponent: () => import('./views/ficha-tecnica/ficha-tecnica').then((m) => m.FichaTecnica),
            },
            {
                path: 'ipca',
                loadComponent: () => import('./views/ipca/ipca').then((m) => m.Ipca),
            },
            {
                path: 'configuracoes',
                loadComponent: () => import('./views/configuracoes/configuracoes').then((m) => m.Configuracoes),
            },
            {
                path: '**',
                redirectTo: 'importacao',
            },
        ],
    },
    { path: '**', redirectTo: '/importacao', pathMatch: 'full' },
];
